import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import { ICalendarEvent } from "../../../../../../../../../motw_core/Calendar/ICalendarEvent";
import { ICalendarState } from "../../../ICalendarState";
import { State } from "source/app/services/UI/State/State";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";

export async function WithCalendarEventsChangingIndicatorAsync(
    calendarEvent: ICalendarEvent,
    Action: () => Promise<any>
) {
    try {
        const occupiedHourNumbers = new CalendarEvent(
            calendarEvent
        ).OccupiedHourNumbers();

        State.ReadClass<ICalendarState>(ESharedComponent.Calendar).setState({
            hoursBeingChanged: occupiedHourNumbers,
        });

        // console.log(`[Calendar] hours being changed: ${[occupiedHourNumbers]}`);

        await Action();
    } finally {
        State.ReadClass<ICalendarState>(ESharedComponent.Calendar).setState({
            hoursBeingChanged: [],
        });
    }
}
